<!-- ============================================================== -->
<!-- Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->

<div class="fold">
  <div id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full"
    data-sidebar-position="absolute" data-header-position="absolute" data-boxed-layout="full"
    class="vertical-layout vertical-menu 2-columns navbar-sticky" data-menu="vertical-menu">
    <!-- ============================================================== -->
    <!-- Topbar header - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <div>
      <header class="topbar" data-navbarbg="skin6" *ngIf="authenticationService.loggedUser">
        <nav class="navbar top-navbar navbar-expand-md navbar-light">
          <!-- <div class="container-fluid navbar-wrapper"> -->
          <div class="navbar-header" data-logobg="skin6" *ngIf="!isHidden">
            <a id="mobileheaderlogo" class="navbar-brand">
              <!-- Logo icon -->
              <b class="logo-icon">
              </b>
              <!--End Logo icon -->
              <!-- Logo text -->
            </a>
            <span id="togglebar" class="navbar-brand logo-text" aria-controls="collapseExample">
              <form title="FullScreen" class="fullscreen ps-3">
                <i class="ti-menu ti-close text-dark"></i>
              </form>
            </span>
            <!-- ============================================================== -->
            <!-- End Logo -->
            <!-- ============================================================== -->
            <!-- ============================================================== -->
            <!-- toggle and nav items -->
            <!-- ============================================================== -->
            <a class="nav-toggler waves-effect waves-light text-dark d-block d-md-none" href="javascript:void(0)">
              <i data-target="#togglebar" class="ti-menu ti-close"></i></a>
          </div>
          <!-- ============================================================== -->
          <!-- End Logo -->
          <!-- ============================================================== -->

          <div class="navbar-collapse collapse" id="navbarSupportedContent" data-navbarbg="skin5">

            <ul class="navbar-nav mt-md-0 px-4">
            </ul>
            <!-- ============================================================== -->
            <!-- toggle and nav items -->
            <!-- ============================================================== -->
            <ul class="navbar-nav ms-auto mt-md-0 ">
              <!-- ============================================================== -->
              <!-- Search -->
              <!-- ============================================================== -->


            </ul>
            <!-- ============================================================== -->
            <!-- Right side toggle and nav items -->
            <!-- ============================================================== -->

            <ul class="navbar-nav">
              <!-- ============================================================== -->
              <!-- User profile and search -->
              <!-- ============================================================== -->
              <ul class="navbar-nav roundprofiles mt-2" style="cursor: pointer;line-height: 25px;">
                <li class="nav-item" ngbDropdown display="dynamic">
                  <a class="nav-link" id=" " ngbDropdownToggle>
                    <i class="fas fa-user align-middle pb-4 text-dark"></i>
                    <i style="color: rgb(0, 0, 0)"></i>
                  </a>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic" style="margin-top: -15px;">
                    <span class="nav-link">
                      <a href="http://202.191.140.74/Aarthi_SLIMS/Forms/fm_Change_Password.aspx">
                        <i class="fa-solid fa-lock text-dark px-1"></i>
                        <span class="px-1 text-center" style="color: black;position: absolute;font-size: 15px;top: 13%;left: 20%;">Change&nbsp;Password</span>
                      </a>
                    </span>

                    <span data-toggle="modal" data-target="#myModal">
                      <a role="dialog">
                        <i class="fa-solid fa-arrow-right-from-bracket" style="position: relative;left: 8%;"></i>
                        <span class="text-center px-3" style="color: black;font-size: 15px;position: absolute;left: 14%;">Logout</span>
                      </a>
                    </span>
                  </div>
                </li>
              </ul>
            </ul>
          </div>   
        </nav>
      </header>
      <div class="page-wrapper" *ngIf="authenticationService.loggedUser">
        <div class="page-breadcrumb">
          <div class="row align-items-center" style="margin-top: -22px;">
            <div class="col-md-4 col-lg-3 col-xs-12 col-sm-12 align-self-center">
              <h2 class="page-title mb-0 p-0" id="user">{{ welcomeUserName }}</h2>
              <div class="d-flex align-items-center">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <a (click)="fnDashBoard();" [ngClass]="{ 'disabled-link': isHidden }" style="cursor:pointer">Dashboard</a>
                    </li>
                    <li aria-current="page" class="breadcrumb-item active">List of Reports</li>
                  </ol>
                </nav>
              </div>
            </div>
            <div class="col-md-4 col-lg-5 col-xs-12 col-sm-12" >
              <!-- <div id="desktopreportstable" >
                <div class="row" id="headersmartreport">
                  <div class=" col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="click-instruction mobile">
                      <img src="assets/images/app_images/smartreport.svg" style="height:30px" alt="cursor clicking on highlighted terms in a report">
                      <p>Click this icon (available near your CT, MRI, PET CT, and Ultrasound reports) to view your customized 'Radiology Smart Report'. An Interactive page will explain the report in a simple language and diagrams. </p>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="col-md-4  col-lg-4 col-xs-12 col-sm-12 align-self-center hide-mobile">
              <div class="text-end upgrade-btn">
                <img class="img-fluid" src="./assets/images/app_images/0logo.png" alt="Reports" />
              </div>
            </div>
            <ul id="mobilesearchbox" class="navbar-nav ms-auto mt-md-0 ">
              <!-- ============================================================== -->
              <!-- Search -->
              <!-- ============================================================== -->
            </ul>
          </div>
        </div>

        <div class="sidenav-overlay"></div>
        <div class="drag-target"></div>


      </div>


      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->






      <!-- END : Body-->

      <div class="wrapper" *ngIf="!authenticationService.loggedUser">
        <router-outlet></router-outlet>
      </div>
      <div class="wrapper" *ngIf="authenticationService.loggedUser">
        <router-outlet></router-outlet>
      </div>

      <!-- LOGOUT CASE MODEL -->

      <div class="modal fade" id="myModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div id="logout">
                <i id="circle" class="fas fa-sign-in-alt"></i>
              </div>
              <div id="logoutheader" class="d-flex flex-column justify-content-center mb-3 text-center">
                <div class="text-uppercase">
                  <h5>logout</h5>
                </div>
                <div class="text-uppercase">
                  <p>Are you sure you want to logout ?</p>
                </div>
              </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
              <div class="modal-body text-center">
                <div class="row">
                  <div class="col-md-6 col-xs-6">
                    <a href="">
                      <button type="button" class="btn btn-red btn-lg " data-dismiss="modal">NO</button></a>
                  </div>
                  <div class="col-md-6 col-xs-6">
                    <button type="button" class="btn btn-lg bg-white" data-dismiss="modal"
                      (click)="fnLogout()">YES</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Topbar header -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- Left Sidebar - style you can find in sidebar.scss  -->
      <!-- ============================================================== -->

      <aside class="left-sidebar" data-sidebarbg="skin6" *ngIf="authenticationService.loggedUser">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar" *ngIf="!isHidden">
          <!-- Sidebar navigation-->
          <nav class="sidebar-nav">
            <ul id="sidebarnav" class="in">
              <!-- User Profile-->
              <li class="sidebar-item selected">
                <a class="sidebar-link waves-effect waves-dark sidebar-link active" 
                  aria-expanded="false">
                  <i class="me-3 fas fa-tachometer-alt" aria-hidden="true"></i>
                  <span class="hide-menu" (click)="fnDashBoard()" style="cursor:pointer">Dashboard</span></a>
              </li>
              <li data-toggle="modal" data-target="#myModal" class="sidebar-item"> <a
                  class="sidebar-link waves-effect waves-dark sidebar-link" href="javascript:void(0);"
                  aria-expanded="false">
                  <i class="me-3 fas fa-arrow-circle-right" aria-hidden="true"></i><span
                    class="hide-menu">Logout</span></a>
              </li>
            </ul>

          </nav>
          <!-- End Sidebar navigation -->
        </div>
        <!-- End Sidebar scroll-->
      </aside>
      <!-- ============================================================== -->
      <!-- End Left Sidebar - style you can find in sidebar.scss  -->
      <!-- ============================================================== -->
    </div>
  </div>
</div>